import { render, staticRenderFns } from "./SpecialIdCreateDialog.vue?vue&type=template&id=0225c252&scoped=true&"
import script from "./SpecialIdCreateDialog.vue?vue&type=script&lang=js&"
export * from "./SpecialIdCreateDialog.vue?vue&type=script&lang=js&"
import style0 from "./SpecialIdCreateDialog.vue?vue&type=style&index=0&id=0225c252&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0225c252",
  null
  
)

export default component.exports